import type { GetProps } from 'antd';
import type { FC } from 'react';
import { StyledOTPInput } from './components/StyledOneTimePassword';

type StyledOTPInputProps = GetProps<typeof StyledOTPInput>;

// TODO: Change the styling according to the figma design once the antd is bumped to v6 https://enmontech.atlassian.net/browse/ENMON-4702
export const OneTimePasswordInput: FC<StyledOTPInputProps> = props => {
  return <StyledOTPInput formatter={str => str.toUpperCase()} {...props} />;
};
